// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__15tA6","content":"LoadingAlert_content__1PlLV"};